<template>
  <div class="gov-info-detail">
    <div class="container">
      <div
        class="flex"
        style="align-items: center;margin-bottom: 25px;padding-top: 25px;"
      >
        <span style="font-size: 14px;">当前位置：</span>
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/govInfo' }"
            >政务信息</el-breadcrumb-item
          >
          <el-breadcrumb-item :to="{ path: '/govInfoList' }"
            >政务列表</el-breadcrumb-item
          >
          <el-breadcrumb-item>政务详情</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="detail-top-box" v-loading="detailLoading">
        <el-card>
          <div>
            <div class="overflow-ellipsis top-title">
              {{ detailInfo.title }}
            </div>
            <div class="top-info">
              <el-row :gutter="20">
                <el-col :span="14"
                  >发布日期：{{ detailInfo.createDate }}</el-col
                >
                <el-col :span="10">查看次数：{{ detailInfo.viewCount }}</el-col>
              </el-row>
            </div>
            <div class="top-line" />
            <div class="summary-box">
              <div v-html="detailInfo.content"></div>
            </div>
          </div>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
import { getGovInfoDetail } from "../../utils/interface"
import { mapState } from "vuex"

export default {
  //   政务详情详情页
  name: "saasDetails",
  metaInfo: {
    title: "政务详情-宁夏工业企业数字化转型公共服务平台", // set a title
    meta: [
      {
        // set meta
        name: "keywords",
        content:
          "saas平台 | 信息化软件 |人力资源软件 | SRM |crm |MES系统 | 生产管理软件 | 党建管理软件",
      },
      {
        // set meta
        name: "description",
        content:
          "宁夏工业企业数字化转型公共服务平台政务详情提供人力资源、行政、采购、营销、财务、党政等信息化产品软件服务，为水泵行业企业提供完整的信息化解决方案。",
      },
    ],
  },
  components: {},

  data() {
    return {
      curUuid: "",
      detailInfo: {},
      detailLoading: false,
      titleInfo: {
        titleName: "政务列表",
        titleForm: "govInfoList",
      },
    }
  },
  computed: {
    ...mapState({
      isLogin: "isLogin",
    }),
  },
  created() {
    this.getParams()
  },
  methods: {
    getParams() {
      this.curUuid = this.$route.query.uuid
      this.titleInfo.titleName = this.$route.query.titleName
      this.titleInfo.titleForm = this.$route.query.titleForm
      this.getDetailByUuid()
    },
    getDetailByUuid() {
      this.detailLoading = true
      getGovInfoDetail(this.curUuid)
        .then((res) => {
          this.detailLoading = false
          this.detailInfo = res.data
        })
        .catch((err) => {
          this.detailLoading = false
        })
    },
  },
}
</script>

<style scoped lang="less">
.gov-info-detail {
  background: #f4f4f4;

  .overflow-ellipsis {
    //整体超出部分隐藏
    overflow: hidden;
    //文本超出部分以...形式展示，同第一行样式代码
    text-overflow: ellipsis;
    //display 块级元素展示
    display: -webkit-box;
    //设置文本行数为2行
    -webkit-line-clamp: 2;
    //设置文本行数为2行
    line-clamp: 2;
    //从上到下垂直排列子元素（设置伸缩盒子的子元素排列方式）
    -webkit-box-orient: vertical;
  }

  .detail-top-box {
    padding-bottom: 15px;

    .top-title {
      font-size: 24px;
      font-weight: bold;
      color: #333333;
      text-align: center;
    }

    .top-info {
      text-align: center;
      width: 50%;
      margin: 20px auto;
      font-size: 14px;
      color: #333333;
    }

    .top-line {
      width: 1200px;
      height: 1px;
      background-color: #039a9a;
      margin-bottom: 25px;
      transform: translateX(-21px);
    }

    .star-box {
      position: relative;

      .star-icon {
        position: absolute;
        color: #c2c2c2;
        cursor: pointer;
      }

      .star-select {
        color: #f7ba2a;
        font-size: 20px;
      }

      .star-normal {
        color: #c2c2c2;
        font-size: 18px;
      }
    }
  }

  .summary-box {
  }

  .container {
    width: 1200px;
    margin: 0 auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/govInfo/infoDetail.vue